module.exports = __webpack_public_path__ + "86675c66.png";